var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":_vm.changelog}},[_vm._v("Changelog")])}
var staticRenderFns = []

export { render, staticRenderFns }